import React from "react";
import { Provider } from "react-redux";
import store from "../configureStore";

export const ViewProvider = props => {
    return <Provider store={props.store || store}>{props.children}</Provider>;
};
